/**
 * Standalone floating language selector — DEPRECATED for AHP brand.
 * AHP now uses the integrated language selector in AhpGlobalHeader.
 * This component is kept for non-AHP brands if they ever need it.
 */
export function LanguageSelector() {
  return null;
}
